<template>
	<div class="cepbank_form_rsv">
		<div v-if="isLoading" style="text-align: center">
			<svg aria-labelledby="loading-40-aria" role="img" height="160" width="100%"><title id="loading-40-aria">Loading...</title><rect role="presentation" x="0" y="0" width="100%" height="100%" clip-path="url(#loading-40-diff)" style="fill: url(&quot;#loading-40-animated-diff&quot;);"></rect><defs role="presentation"><clipPath id="loading-40-diff"><rect x="0" y="13" rx="4" ry="4" width="100%" height="9"></rect><rect x="0" y="29" rx="4" ry="4" width="100" height="8"></rect><rect x="0" y="50" rx="4" ry="4" width="100%" height="10"></rect><rect x="0" y="65" rx="4" ry="4" width="100%" height="10"></rect><rect x="0" y="79" rx="4" ry="4" width="100" height="10"></rect><rect x="0" y="99" rx="5" ry="5" width="100%" height="200"></rect></clipPath><linearGradient id="loading-40-animated-diff"><stop offset="0%" stop-color="#f5f6f7" stop-opacity="1"><animate attributeName="offset" values="-2; -2; 1" keyTimes="0; 0.25; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#eee" stop-opacity="1"><animate attributeName="offset" values="-1; -1; 2" keyTimes="0; 0.25; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#f5f6f7" stop-opacity="1"><animate attributeName="offset" values="0; 0; 3" keyTimes="0; 0.25; 1" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg>
		</div>
		<div v-if="formProcess > 0">
			<div class="alert alert-success" v-if="formProcess == 200">
				{{ t.form.success }}
			</div>
			<div class="alert alert-danger" v-if="formProcess == 403">
				<noAvailablePayment :text="t.payment_isnot_available" />
			</div>
			<div class="alert alert-danger" v-if="formProcess == 404">
				<noAvailablePayment :text="t.payment_isnot_available" />
			</div>
		</div>
		<symForm :options="opt" :data="formData" v-on:sended="getForm" :form="Form" :formProcess="formProcess" v-if="Form" />
	</div>
</template>
<script>

    import noAvailablePayment from '@/components/payments/noAvailablePayment.vue'
    import symForm from '@/components/form/symForm.vue'
    export default {
        name: 'extend',
        components: { symForm,noAvailablePayment },
        data () {
            return {
                isLoading: false,
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                Form: null,
                translationForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: []
            }
        },
        watch: {
            '$route.params.method' () {
                this.getForm();
            }
        },
        mounted () {
            this.getForm();

        },
        methods: {
            resetStatus () {
                this.formProcess = 0;
            },
            async multiSelect () {

        var e = document.getElementsByClassName("choicesx");
        for (var i = 0; i < e.length; i++){
            var name = e[i].getAttribute("name");

            var element = e[i];

            var example = new Choices(element, {
                removeItemButton: true,

            });
        }

        //CKEDITOR.replaceAll();
    },
    async getForm (data) {

        if(!this.isLoading) {
            this.isLoading = true;
            this.Form = null;
            this.formProcess = 0;
            if(data) {
                //this.Form = null;
                this.$http.post(api+'api/v1/'+this.$route.query.t+'-payment/methods/'+this.$route.params.method,
                    data )
                    .then(response => {

                    this.Form = response.body.result;
                    this.formProcess = 200;
                    this.isLoading = false;
                    //swal('', this.t.processing.success, "success")

                    if (response.body.redirect) {
                        window.location = response.body.redirect
                    }
                    setTimeout(this.resetStatus, 5000);

                }, response => {
                    this.Form = response.body.result;
                    this.formProcess = 400;
                    this.isLoading = false;

                    //swal(this.t.processing.error, this.t.processing.check, "error")
                })

            } else {
                this.$http.get(api+'api/v1/'+this.$route.query.t+'-payment/methods/'+this.$route.params.method)
                    .then(response => {

                    this.Form = response.body.result;
                    this.formData = response.body.form_data;
                    this.isLoading = false;

            }, response => {
                    this.isLoading = false;
                    this.formProcess = response.status;
                })
            }
        }
    },
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


	.cepbank_form_rsv .titlex {
		font-size: 18px;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/payments/form/extend.vue